import { strings } from 'APP_ROOT/localization';

export default class MapboxToggleRavenTrailsControl {

    mapboxControlShouldShowRavenTrails;
    mapboxControlCallback;

    constructor(showRavenTrailsByDefault, callbackForButtonEventListener) {
        this.mapboxControlShouldShowRavenTrails = showRavenTrailsByDefault;
        this.mapboxControlCallback = callbackForButtonEventListener;
    }

    buttonEventListener = () => {

        this.mapboxControlShouldShowRavenTrails = !this.mapboxControlShouldShowRavenTrails; // toggle
        this.mapboxControlCallback(this.mapboxControlShouldShowRavenTrails);
    }

    onStyleChange() {

        if (!this.map) {
            console.error("onStyleChange triggered while map property is invalid (" + (this.map) + "). Doing nothing.");
            return;
        }

        this.mapboxControlCallback(this.mapboxControlShouldShowRavenTrails);
    }

    onAdd(map) {
        this.map = map;
        this.container = this.container();
        return this.container;
    }

    onRemove() {
        this.container.parentNode.removeChild(this.container);
        this.mapboxComponentClassCallback = undefined;
        this.map = undefined;
    }

    button() {

        var imageElement = document.createElement('img');
        imageElement.src = '/images/map-btn-trails.png';
        imageElement.style = "width: 30px; padding: 3px;"; /* using padding to shrink the icon down while keeping overall width 30px */

        var buttonElement = document.createElement('button');
        buttonElement.id = 'showRavenTrailsBtn';
        buttonElement.title = strings.map_controls_label_toggle_vehicle_trails;
        buttonElement.appendChild(imageElement);

        buttonElement.addEventListener('click', this.buttonEventListener);

        var buttonWrapper = document.createElement('div');
        buttonWrapper.appendChild(buttonElement);

        return buttonWrapper;
    }

    container() {
        var buttonWrapperContainer = document.createElement('div');
        buttonWrapperContainer.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
        buttonWrapperContainer.appendChild(this.button());
        return buttonWrapperContainer;
    }
}